// Function to convert Firestore timestamp (ISO 8601) to formatted date string "10 Jan 2025"
const convertTimestamp = (timestamp) => {
  // Convert ISO string to Date object
  const date = new Date(timestamp);

  // Extract the day, month, and year from the Date object
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" }); // Get month name (short)
  const year = date.getFullYear();

  // Return the formatted string
  return `${day} ${month} ${year}`;
};

export default convertTimestamp;
